import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import RouterStepper from 'components/Stepper/RouterStepper';
import { LargeHeader, Header } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { HOME } from 'routes/home/paths';
export default function RegisterVehicleLayout({
  onForwardButtonClick,
  hasForwardButtonDisabled,
  altForwardButtonText,
  children,
  subtitle,
  isForwardButtonLoading,
  isFinalStep
}) {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    isBusinessCustomer
  } = useCurrentCustomer();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, isBusinessCustomer ? t('register_vehicle.order_new_tag') : t('register_vehicle.title')), /*#__PURE__*/React.createElement(Box, null, subtitle && /*#__PURE__*/React.createElement(Box, {
    py: 2
  }, /*#__PURE__*/React.createElement(Header, null, subtitle)), children), /*#__PURE__*/React.createElement(RouterStepper, {
    onBackButtonClick: () => push(HOME),
    onForwardButtonClick: onForwardButtonClick,
    hasForwardButtonDisabled: hasForwardButtonDisabled,
    altForwardButtonText: altForwardButtonText,
    isForwardButtonLoading: isForwardButtonLoading,
    isFinalStep: isFinalStep
  }));
}
RegisterVehicleLayout.defaultProps = {
  subtitle: undefined
};